import { z } from 'zod';
import { IsoDateTime, Uuid } from './common.js';
/**
 * Notifications internes (cloche de l'en-tête).
 *
 * Périmètre minimal du sprint 2.4 : messages produits par le PMS pour un
 * utilisateur du tenant (relance de documents manquants, tâche assignée).
 * Les envois **au client** (e-mail, WhatsApp) restent portés par le module
 * Notifications sortantes (`notification.send`), sans rapport avec cette table.
 */
/**
 * Nature d'une notification interne.
 *
 * Le sprint 2.7 (E-15) aligne cette énumération sur `NotificationTopic`
 * (`analytics.ts`) : chaque sujet abonnable produit une notification interne du
 * même code, ce qui permet à la cloche et aux préférences de parler la même
 * langue. `TASK_ASSIGNED`, `PAYMENT_EXPECTED` et `OTHER` restent les valeurs
 * historiques du sprint 2.4, sans sujet abonnable correspondant.
 */
export const NotificationKind = z.enum([
    'DOCUMENT_MISSING',
    'TASK_ASSIGNED',
    'PAYMENT_EXPECTED',
    'RESERVATION_TO_CONFIRM',
    'OPTION_EXPIRING',
    'ARRIVAL_TODAY',
    'DEPARTURE_TODAY',
    'PAYMENT_OVERDUE',
    'INVOICE_UNPAID',
    'RESERVATION_CANCELLED',
    'MAINTENANCE',
    'CASH_VARIANCE',
    'DAILY_DIGEST',
    'OTHER',
]);
export const Notification = z.object({
    id: Uuid,
    kind: NotificationKind,
    title: z.string(),
    body: z.string().nullable(),
    entityType: z.string().nullable(),
    entityId: Uuid.nullable(),
    entityReference: z.string().nullable(),
    createdAt: IsoDateTime,
    readAt: IsoDateTime.nullable(),
});
export const ListNotificationsQuery = z.object({
    unreadOnly: z
        .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
        .transform((value) => value === true || value === 'true' || value === '1')
        .default(false),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    cursor: z.string().max(512).optional(),
});
export const UnreadNotificationCount = z.object({ unread: z.number().int().nonnegative() });
//# sourceMappingURL=notifications.js.map